import {
  List,
  Datagrid,
  ImageField,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
} from 'react-admin';

const HomeCarouselList = (props: any) => (
  <List
    {...props}
    sort={{ field: 'displayOrder', order: 'ASC' }}
    perPage={50}
    title="Imagens da Home"
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <ImageField
        source="imageUrl"
        label="Imagem"
        sx={{ '& img': { maxWidth: 160, maxHeight: 90, objectFit: 'contain' } }}
      />
      <TextField source="title" label="Título" emptyText="--" />
      <NumberField source="displayOrder" label="Ordem" textAlign="center" />
      <BooleanField source="isActive" label="Ativa" textAlign="center" />
      <EditButton />
    </Datagrid>
  </List>
);

export default HomeCarouselList;
